import React, { useState } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { Avatar, Spin } from "antd";
import ImageHelp from "../../Help/pages/component/imageHelp";
import '../utils/style.css'

const ProfileImage = ({ user, size }) => {
    
  const fileSource = user?.fileName ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${user?.fileName}` : null;

  return (
    <Card className="card-animate">
        <CardBody className="p-4">
            <div className="text-center mb-2">
                <Avatar size={size}>
                    <ImageHelp fileSource={fileSource} width="100%"/>
                </Avatar>
            </div>
        </CardBody>
    </Card>
  );
};

export default ProfileImage;
